import React, { PropsWithChildren } from 'react';
import { FieldErrors, FieldValues, FormProvider, UseFormReturn } from 'react-hook-form';

interface FormContainerProps<TForm extends FieldValues> extends PropsWithChildren {
  readonly onSubmit: (data: TForm) => void;
  readonly form: UseFormReturn<TForm>;
  readonly className?: string;
}

export const FormContainer = <TForm extends FieldValues>({
  children,
  form,
  onSubmit,
  className = '',
}: FormContainerProps<TForm>) => {
  const onError = (error: FieldErrors) => console.error(error);

  return (
    <FormProvider {...form}>
      <form className={className} onSubmit={form.handleSubmit(onSubmit, onError)}>
        {children}
      </form>
    </FormProvider>
  );
};
